<template>
    <div :class="$style.right">
        <div :class="$style.right_wrapper">
            <AdContainer
                type="sidebar"
                :backgroundClass="$style.ad"
            />
            <AdContainer type="sidebar_bottom" />
        </div>
    </div>
</template>
<script lang="ts" setup>
import AdContainer from '@/components_new/AdContainer/AdContainer.vue'
</script>
<style module>
.right {
    width: var(--global-right-pannel-width);
    display: block;
    position: relative;
}
.ad {
    background-color: var(--experimental-purple-graphit);
    border-radius: var(--radius-12);
}
.right_wrapper {
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
</style>
